const initialSharedState = {
    gdprModalShown: false,
    loginModalShown: false,
};

export const getInitialSharedState = ({
    organizers = [],
    organizerData = {},
    isAuthenticated,
}) => ({
    ...initialSharedState,
    organizers,
    organizerData,
    isAuthenticated,
});


const reduceDefaultState = (memo, item) => ({
    ...memo,
    [item]: {
        id: item,
        followedByYou: null,
    },
});

export const computeMergedState = (initialState) => {
    const {organizerData = {}, organizers} = initialState;
    const updatedOrganizers = Object.keys(organizerData).length ?
        [...new Set([...organizers, ...Object.keys(organizerData)])] :
        organizers;
    const defaultOrganizerData = updatedOrganizers.reduce(reduceDefaultState, {});

    return {
        ...initialState,
        organizers: updatedOrganizers,
        organizerData: {
            ...defaultOrganizerData,
            ...organizerData,
        },
    };
};
